import { Typography } from '@la/ds-ui-components';

export default function ActivityCheckIn() {
  return (
    <Typography variant="ui" size="large" weight="bold">
      Check In
    </Typography>
  );
}
